import React, { Fragment } from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import { Button, Col,  Form,  Input,  Row, Select} from 'antd';
import { SPAN_FULL, SPAN_ONE_THIRD, MARGIN_SM, SPAN_TWO_QUARTERS } from '../../../../../../../styles/constants';
import { showFileMappingWizardAddFieldFunctionTrimFormChange, onClearTrim } from '../../actions';
import _ from "lodash";

const mapStateToProps = state => ({
  mergedHeader: state.scenes.dataManager.fileMapping.components.wizard.shared.mergedHeader,
  TrimFormData: state.scenes.dataManager.fileMapping.components.wizard.components.addField.TrimFormData,
  functionType: state.scenes.dataManager.fileMapping.components.wizard.components.addField.functionType,
});

const mapDispatchToProps = dispatch => ({
  onChange: fields => dispatch(showFileMappingWizardAddFieldFunctionTrimFormChange(fields)),
  onClearTrim: () => dispatch(onClearTrim()),
});

const mapPropsToFields = ({TrimFormData}) => ({
  selectValue: Form.createFormField({value: TrimFormData !== null ? TrimFormData.selectValue : null}),
  toTrimValue: Form.createFormField({value: TrimFormData !== null ? TrimFormData.toTrimValue : null}),
})

const onFieldsChange = (props, fields) => props.onChange(_.mapValues(fields, ({value}) => value));

const FileMappingWizardTrimWizard = ({
                                                t,
                                                form,
                                                mergedHeader,
                                                onClearTrim,
                                              }) => {
                          
  return (
    
    <Fragment>
        <Col span={SPAN_FULL}>
          <Row type='flex' justify='space-between'>
            <Col span={SPAN_ONE_THIRD}>
              <Form.Item
                className="form-item"
                label={t('data.fileMapping.addField.functionWizard.field.label')}
              >
                {form.getFieldDecorator("selectValue")(
                  <Select
                    title={form.getFieldValue("selectValue")}
                    >
                    {mergedHeader.map((field) => (
                      <Select.Option
                        key={field.name}
                        value={field.name}
                        title={`${field.name}`}
                      >
                        {field.name}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col span={SPAN_TWO_QUARTERS}>
              <Row type='flex'>
                <Form.Item
                  className='form-item'
                  label={t('data.fileMapping.addField.functionWizard.toTrim.label')}
                  style={{marginRight: MARGIN_SM}}
                  >
                    {form.getFieldDecorator("toTrimValue")(
                      <Input
                      title={form.getFieldValue("toTrimValue")}
                      style={{
                        width: 200
                      }}
                      />
                      )}
                </Form.Item>
              </Row>
            </Col>
            <Col>
              <Button
                onClick={onClearTrim}
                icon="delete"
              >
              </Button>
            </Col>
          </Row>
        </Col>
    </Fragment>
);
}

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  Form.create({mapPropsToFields, onFieldsChange})
  )(FileMappingWizardTrimWizard);